import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  Input,
  Button,
  Form,
  Space,
  Modal,
  Col,
  Row,
  Select,
  Spin,
  TreeSelect,
} from "antd";
import { useTranslation } from "react-i18next";

const { TreeNode } = TreeSelect;

const ModalForm = ({
  treeSelectProps,
  titleModal,
  form,
  handleSubmitForm,
  showModal,
  handleClodeModal,
  loadingModal,
}) => {
  const { treeData, treeDataDepartmentValue } = treeSelectProps;
  const { t } = useTranslation();
  const validateInput = (_, value) => {
    if (!value || value?.trim() === "") {
      return Promise.reject();
    }
    return Promise.resolve();
  };
  const validateInputNumber = (_, value) => {
    if (!value || value?.trim() === "" || value <= 0) {
      return Promise.reject();
    }
    return Promise.resolve();
  };

  useEffect(() => {
    if (!showModal) {
      form.resetFields();
    }
  }, [showModal]);

  const handleResetForm = async () => {
    form.resetFields();
  };

  return (
    <>
      <Modal
        forceRender={true}
        title={titleModal}
        width={500}
        open={showModal}
        toggle={handleClodeModal}
        onCancel={handleClodeModal}
        centered={true}
        footer={null}
      >
        <Spin spinning={loadingModal} size="large">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmitForm}
            autoComplete="off"
          >
            <Row gutter={15}>
              <Col hidden={true}>
                <Form.Item name="id" label="Id">
                  <Input />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  name="shiftName"
                  label={t("shiftAttendanceName")}
                  rules={[
                    {
                      validator: validateInput,
                      message: t("validateShiftAttendanceName"),
                      type: "string",
                      min: 1,
                    },
                  ]}
                  style={{ marginBottom: "22px" }}
                >
                  <Input
                    placeholder={t("placeHolderShiftAttendanceName")}
                    allowClear={true}
                  />
                </Form.Item>
              </Col>
              <Col lg={{ span: 24 }}>
                <Form.Item
                  name="departments"
                  label={t("companyDepartmentAndGroup")}
                  rules={[
                    {
                      required: true,
                      message: t("validateSelectCompanyDepartmentAndGroup"),
                    },
                  ]}
                  style={{ marginBottom: "22px" }}
                >
                  <TreeSelect
                    showSearch
                    treeNodeFilterProp="title"
                    style={{ width: "100%" }}
                    placeholder={t(
                      "placeHolderSelectCompanyDepartmentAndGroup"
                    )}
                    allowClear
                    value={treeDataDepartmentValue}
                    treeCheckable={true}
                    treeDefaultExpandAll
                  >
                    {treeData &&
                      treeData?.map((data) => {
                        const disableChildren = data.children.length === 0;
                        return (
                          <TreeNode
                            key={data.key}
                            value={data.value}
                            title={data.title}
                            disabled={true}
                          >
                            {!disableChildren
                              ? data.children.map((child) => {
                                  const disableChildrenOfChild =
                                    child.children.length === 0;
                                  return (
                                    <TreeNode
                                      key={child.key}
                                      value={child.value}
                                      title={child.title}
                                    >
                                      {!disableChildrenOfChild
                                        ? child.children.map((childOfChild) => {
                                            return (
                                              <TreeNode
                                                key={childOfChild.key}
                                                value={childOfChild.value}
                                                title={childOfChild.title}
                                              ></TreeNode>
                                            );
                                          })
                                        : null}
                                    </TreeNode>
                                  );
                                })
                              : null}
                          </TreeNode>
                        );
                      })}
                  </TreeSelect>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="shiftMinute"
                  label={t("attendanceTimeMinutes")}
                  rules={[
                    {
                      required: true,
                      validator: validateInputNumber,
                      message: t("validateAttendanceTime"),
                      type: "number",
                      min: 1,
                    },
                  ]}
                  style={{ marginBottom: "22px" }}
                >
                  <Input
                    placeholder={t("placeHolderAttendanceTime")}
                    type="number"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item className="mt-2 text-center">
              <Space>
                <Button type="primary" htmlType="submit">
                  {t("save")}
                </Button>

                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => handleResetForm()}
                >
                  {t("reload")}
                </Button>

                <Button type="danger" onClick={handleClodeModal}>
                  {t("close")}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};
ModalForm.propTypes = {
  titleModal: PropTypes.string,
  handleSubmitForm: PropTypes.func,
  handleClodeModal: PropTypes.func,
  showModal: PropTypes.bool,
  form: PropTypes.any,
  listDepartment: PropTypes.any,
  loadingModal: PropTypes.bool,
};
export default ModalForm;
